<ng-container *ngFor="let validator of validations">
	<app-password-validator-row [success]="password | match: validator.regex">
		{{ validator.label | translate }}
	</app-password-validator-row>
</ng-container>
